// Die Kennzeichen-Grafik: Euro-Band mit Sternenkranz links (Flaggenband.tsx),
// Eingabefeld rechts. Selbst als SVG/CSS gezeichnet, wie CLAUDE.md verlangt
// (keine Assets aus der Original-App, keine Kreiswappen).
//
// WICHTIG (IMG_4893, 01.09.2026): Es gibt kein eigenes Eingabefeld
// unterhalb der Grafik. Die Zelle rechts im Kennzeichen IST das
// Eingabefeld, dort erscheint auch der Cursor und dort holt sich die
// native Tastatur den Fokus.

import type { ChangeEvent } from "react";
import type { Land } from "../lib/bundle.js";
import { Flaggenband } from "./Flaggenband.js";

export function KennzeichenGrafik({
  land,
  wert,
  onWertAendern,
}: {
  land: Land | undefined;
  wert: string;
  onWertAendern: (naechster: string) => void;
}) {
  return (
    // w-60 statt w-full: per Pipette aus IMG_4893 gemessen (Plattenbreite
    // ~245px bei 393px Bildschirmbreite, also fest und nicht bildschirmfuellend
    // wie ein natives dp-Mass). uppercase entfaellt hier bewusst: die Grossschrift
    // fuer eingetippte Zeichen kommt schon aus eingabeAendern() (toUpperCase),
    // die CSS-Klasse haette sonst auch den Platzhaltertext "Kennzeichen"
    // grossgeschrieben, der im Original klein beginnt und truncated.
    <div className="flex h-24 w-60 items-stretch overflow-hidden rounded-lg border-2 border-black bg-white shadow">
      <Flaggenband land={land} breite={56} hoehe={96} sternGroesse={24} schriftKlasse="text-sm" />
      <input
        value={wert}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onWertAendern(e.target.value)}
        placeholder="Kennzeichen"
        autoCapitalize="characters"
        autoComplete="off"
        spellCheck={false}
        className="min-w-0 flex-1 truncate px-2 text-center text-3xl font-bold tracking-wide text-black outline-none placeholder:text-neutral-400"
      />
    </div>
  );
}
